// extracted by mini-css-extract-plugin
module.exports = {"borderRadius":"4px","unit":"8px","container":"terms-and-conditions-page__container____1DriG"};